import React from 'react';
import {BrowserRouter, Route, Switch } from 'react-router-dom';
import Logon from './Components/Logon';
import Dashboard from './Components/Dashboard';

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch> 
        <Route path="/" exact component={Logon} />
        <Route path="/dashboard" component={Dashboard} />
      </Switch>
    </BrowserRouter>
  );
}
  

  